<div class="data-main-content" id="data-main-content" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="18px">
  <div class="arrow-div" id="arrow-right" fxLayout="column" fxLayoutAlign="center center">
    <evc-nav-button  mat-mini-fab color="primary" class="arrow-button" (click)="changeIndex(true)"
      [disabled]="!isBackImage || isPreviewReport" size="sm" [rightIcon]="'angle-left'" type="cta" variant="round" >
    </evc-nav-button >
  </div>
  <div class="dialog-container">
    <div class="inspection-video-div flex-row" [class.with-bookmark]="isPlayableVideo && bookmarkTimes?.length > 0">
      <div class="vdo-div">
        <video class="video" id="video-playback" controls="true" alt="" [hidden]="!isPlayableVideo" [src]="inspectionImage.filePath">
        </video>

        <div class="error-video" *ngIf="!isPlayableVideo && !isLoading">
          <mat-icon class="material-icons-outlined error-video-icon">play_disabled</mat-icon>
          <div class="error-video-text">{{ 'videoDataEditComponent.notSupportedMessage' | translate }}</div>
        </div>

        <div class="bookmark-div" *ngIf="isPlayableVideo">
          <div class="timeline-wrapper">
            <div class="time-display start-time">
              {{ 0 | timeCount }}
            </div>
            <div class="timeline-main-area">
              <svg class="timeline-svg-track" viewBox="0 0 1000 10" preserveAspectRatio="none" aria-hidden="true">
                <rect class="track-background" x="0" y="0" width="100%" height="100%" />
              </svg>
              <div class="marker-overlay">
                <ng-container *ngFor="let time of bookmarkTimes;let i = index;">
                  <div class="index"
                      [style.left]="getLettPosition(time) + '%'"
                      [matTooltip]="getMarkTimeLabel(time)"
                      matTooltipPosition="above"
                      (click)="onSelect(time, $event)"
                      [style.z-index]="11 + i"
                      [class.selected]="selectedTime === time && isBookMarkSelected">
                      <span *ngIf="selectedTime === time && isBookMarkSelected" class="bookmark-svg">
                        <svg [class.select]="isBookMarkSelected">
                          <use xlink:href="assets/icons/inspection/bookmark-selected.svg#bookmark-selected" href="assets/icons/inspection/bookmark-selected.svg#bookmark-selected"/>
                        </svg>
                      </span>
                      <span *ngIf="selectedTime !== time" class="bookmark-svg">
                        <svg>
                          <use xlink:href="assets/icons/inspection/bookmark-unselected.svg#bookmark-unselected" href="assets/icons/inspection/bookmark-unselected.svg#bookmark-unselected"/>
                        </svg>
                      </span>
                    <div class="delete-button-container" *ngIf="selectedTime === time && isBookMarkSelected">
                      <evc-nav-button
                        id="delete"
                        type="icon"
                        leftIcon="trash-can"
                        size="sm"
                        [matTooltip]="'imageEditDialog.delete' | translate"
                        (click)="removeBookmark(i); $event.stopPropagation()">
                      </evc-nav-button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="time-display end-time">
              {{ duration | timeCount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="arrow-div" id="arrow-right" fxLayout="column" fxLayoutAlign="center center">
    <evc-nav-button  mat-mini-fab color="primary" class="arrow-button" (click)="changeIndex(false)"
      [disabled]="!isForwardImage || isPreviewReport" size="sm" [rightIcon]="'angle-right'" type="cta" variant="round" >
    </evc-nav-button >
  </div>


</div>
